const namespaced = true

import api from '../../../api/sap/whse_journal_sap.js';
import { downloadFile } from '../../../src/helpers/util.js'

const state = {
    whseJournalByDate: [],
    items: [
        { id: 1, name: 'Hoy' },
        { id: 2, name: 'De 3 dias' },
        { id: 3, name: 'De 1 semana' },
        { id: 4, name: 'De 1 mes' },
        { id: 5, name: 'Manualmente' }
    ],
    loading: false

}

const mutations = {
    MUTATION_FLAG(state, flag) {
        state.loading = flag
    },
    MUTATION_SET_DATA_DATE(state, data) {
        state.whseJournalByDate = data
    },
    MUTATION_RESET_DATA(state) {
        state.whseJournalByDate = []
    },

}
const actions = {
    getWhseJournalByDate(context, data) {
        const silent = data.silent === true;
        return new Promise((resolve) => {
            if (!silent) context.commit('MUTATION_FLAG', true);
            api.load_whse_journal_by_date(data).then((res) => {
                context.commit('MUTATION_SET_DATA_DATE', res.data);
                if (!silent) context.commit('MUTATION_FLAG', false);
                resolve(res.data);
            }).catch(() => {
                context.commit('MUTATION_RESET_DATA');
            });
        });
    },

    exportDocument(context, data) {

        return new Promise((resolve, reject) => {
            //context.commit("MUTATION_SET_LOADING_DOWNLOAD", true);
            api.load_document_by_date(data).then(function (res) {
                const today = new Date();
                const fileName = `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}_movimientos-de-almacen_.xlsx`;
                downloadFile(res.data, fileName);
                // context.commit("MUTATION_SET_LOADING_DOWNLOAD", false);
                resolve(res.data);
            })
                .catch((e) => {
                    // context.commit("MUTATION_SET_LOADING_DOWNLOAD", false);
                    
                    const errorMsg = e.messages;
                    let finalMessage = "Ocurrió un error al exportar";
                    if (errorMsg === "undefined\nundefined" || !errorMsg || errorMsg.trim() === "" || typeof errorMsg !== "string") {
                        finalMessage = "Sin suficientes registros";
                    } else {
                        finalMessage = errorMsg;
                    }
                    context.dispatch( "notifications/add", {color: "error", visibility: true, timeout: 5000, text: finalMessage, }, { root: true } );
                    reject();
                    console.log(e);
                });
        });
    },

}

const getters = {
    dateRangeByItem: () => (id) => {
        const today = new Date();
        const formatDate = (d) => d.toISOString().split('T')[0];

        const cloneAndSubtract = (days) => {
            const date = new Date(today);
            date.setDate(date.getDate() - days);
            return formatDate(date);
        };

        switch (id) {
            case 1:
                return { start_date: formatDate(today), end_date: formatDate(today) };
            case 2:
                return { start_date: cloneAndSubtract(3), end_date: formatDate(today) };
            case 3:
                return { start_date: cloneAndSubtract(7), end_date: formatDate(today) };
            case 4:
                return { start_date: cloneAndSubtract(30), end_date: formatDate(today) };
            default:
                return null;
        }
    },
    itemsFilter: (state) => state.items
}

export default {
    namespaced,
    state,
    getters,
    mutations,
    actions
}